import { render, staticRenderFns } from "./claimApplication.vue?vue&type=template&id=1430f6ca"
import script from "./claimApplication.vue?vue&type=script&lang=js"
export * from "./claimApplication.vue?vue&type=script&lang=js"
import style0 from "./claimApplication.vue?vue&type=style&index=0&id=1430f6ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports